t = require('views/internal/teacup-with-helpers')('archived_card_options')

module.exports = t.renderable ({ editable, canReopen, canDelete, reOpenText }) ->
  if editable && (canReopen || canDelete)
    t.p '.quiet', { style: 'margin-left: 8px;' }, ->
      if canReopen
        t.a '.js-reopen', { href: '#' }, ->
          t.text reOpenText
        if canDelete
          t.text " - "
      if canDelete
        t.a '.js-delete', { href: '#' }, ->
          t.format 'delete'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/archived_card_options.coffee